import { type ReactNode, useState } from "react";
import { ClickableIcon } from "../../../../components/Icon/ClickableIcon.tsx";
import { PanelSection } from "./PanelSection.tsx";

export const WrappedPanelSection = ({
  title,
  className,
  variant = "primary",
  isBeta = false,
  infoContent,
  children,
}: {
  title: string;
  className?: string;
  variant?: "primary" | "secondary";
  isBeta?: boolean;
  infoContent?: ReactNode;
  children?: ReactNode;
}) => {
  const [isSectionOpen, setIsSectionOpen] = useState(false);
  return (
    <PanelSection
      title={title}
      rightItem={
        <ClickableIcon
          name={isSectionOpen ? "ChevronUp" : "ChevronDown"}
          size="sm"
          variant="tertiary"
          onClick={() => setIsSectionOpen(!isSectionOpen)}
        />
      }
      className={className}
      variant={variant}
      infoContent={infoContent}
      isBeta={isBeta}
    >
      {isSectionOpen && children ? children : null}
    </PanelSection>
  );
};
